import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import taskStyle from "../../../assets/css/modules/taskManagement.module.css";
import MyHistoryTable from "./myHistory_Table";
import MyTaskTable from "./myTask_Table";
import { DataTableLoader, FormLoader } from "../../../utils/Loader";
import { rightSideTaskSaveManagementDetailsReact } from "../../../store/actions";
import TaskSaveDetails from "./RightSide/TaskSaveDetails";
import "../../../assets/css/task-management.css";
const TaskFollowUpScreen = ({
  toggleModal,
  actionModule,
  activeOrganizationInfo,
  activityHistoryAllInfo,
  isFetching,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("my-task-history");
  const [rowType, setRowType] = useState();

  const { data: taskSaveManagementDetails, isFetching: isFetchingTaskSave } =
    useSelector(
      (state) => state.right_side_task_save_management_details_react,
      shallowEqual,
    );
  const toggleTab = (tab) => activeTab !== tab && setActiveTab(tab);
  const closeBtn = (
    <div className="links_right w-45">
      <button className="modal_close" onClick={toggleModal} type="button">
        <img title="Attached File" src="/images/close.svg" />
      </button>
    </div>
  );
  const onRowClick = (rowData) => {
    setRowType(rowData.rowType);
    if (rowData.rowType === "taskSave") {
      const payload = {
        loogedinuser: activeOrganizationInfo?.LoginEmail,
        companyguid: rowData?.companyguid,
        organization: rowData?.organization,
        primaryprogram: rowData?.primaryprogram,
        mainTaskId: rowData?.mainTaskSaveId,
        taskId: rowData?.taskid,
        taskName: rowData?.taskType,
        status: rowData?.taskstatus,
        EnableAssingnedUser: rowData?.enableAssingnedUser,
        TaskSaveId: rowData?.taskSaveId,
        recordid: rowData?.TaskManagerDetails?.recordid,
        statustypeid: rowData?.statustypeid,
        userid: rowData?.userid,
        metricName: rowData?.metricName || " ",
        frommyhistory: activeTab === "my-task-history" ? 1 : 0,
      };

      dispatch(rightSideTaskSaveManagementDetailsReact(payload));
      return;
    }

    if (rowData.rowType === "systemTask") {
      // getindividualrec(row);
      return;
    }

    if (rowData.rowType === "aimlTask") {
      if (rowData.tasktype?.toLowerCase() === "coach - client requested") {
        // getIndividualAIMLRecordNew(row.recordid);
      } else {
        // getindividualrecAIML(row.recordid);
      }
    }
  };
  return (
    <div>
      <ModalHeader
        toggle={toggleModal}
        close={closeBtn}
        className="custom-modal metric_header"
      >
        <div className="d-flex flex-start align-center">
          <div className="title">Task Management</div>
        </div>
      </ModalHeader>
      <ModalBody
        id="task-management-custom"
        style={{ overflow: "scroll", maxHeight: "85vh" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className={`col-md-1 px-0 ${taskStyle["highlight-section"]}`}
              style={{
                maxWidth: "12.5%",
              }}
            >
              <Nav
                pills
                className="nav flex-column nav-pills"
                id="task-management-tab"
              >
                <NavLink
                  className="nav-link"
                  id="my-task-tab"
                  onClick={() => toggleTab("my-task")}
                >
                  <div
                    className={`${taskStyle.View_all_records} ${
                      activeTab === "my-task" && taskStyle.highlight
                    }`}
                  >
                    <img
                      className={taskStyle.myhistory}
                      src="/images/task.jpg"
                    />
                    <h3 className={taskStyle.mytsk_head}>My Tasks</h3>
                  </div>
                </NavLink>
                <NavLink
                  className="nav-link"
                  id="my-task-history-tab"
                  onClick={() => toggleTab("my-task-history")}
                >
                  <div
                    className={`${taskStyle.View_all_history} ${
                      activeTab === "my-task-history" && taskStyle.highlight
                    }`}
                  >
                    <img
                      className={taskStyle.myhistory}
                      src="/images/task.png"
                    />
                    <h3 className={taskStyle.mytsk_history}>My History</h3>
                  </div>
                </NavLink>
              </Nav>
            </div>
            <div className="col-md-7 p-0">
              <TabContent
                className="tab-content"
                id="task-management-tabContent"
                activeTab={activeTab}
              >
                <TabPane tabId="my-task">
                  <div className="table-reponsive" id="tblTableData">
                    {isFetching ? (
                      <div className="text-center">
                        <DataTableLoader width="100%" />
                      </div>
                    ) : (
                      <MyTaskTable
                        rowData={activityHistoryAllInfo}
                        onRowClick={onRowClick}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tabId="my-task-history">
                  {isFetching ? (
                    <div className="text-center">
                      <DataTableLoader width="100%" />
                    </div>
                  ) : (
                    <MyHistoryTable
                      rowData={activityHistoryAllInfo}
                      onRowClick={onRowClick}
                    />
                  )}
                </TabPane>
              </TabContent>
            </div>
            <div className="col-md-4 border-0">
              {isFetchingTaskSave ? (
                <div className="text-center">
                  <FormLoader width="100%" />
                </div>
              ) : (
                <>
                  {rowType === "taskSave" && (
                    <TaskSaveDetails
                      taskSaveManagementDetails={taskSaveManagementDetails}
                    />
                  )}

                  {rowType === "systemTask" && (
                    <>
                      <h4>System Task</h4>

                      {/* <SystemTaskDetails
                        taskSaveManagementDetails={taskSaveManagementDetails}
                      /> */}
                    </>
                  )}

                  {rowType === "aimlTask" && (
                    <>
                      <h4>AIML Task</h4>

                      {/* <AIMLTaskDetails
                        taskSaveManagementDetails={taskSaveManagementDetails}
                      /> */}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
    </div>
  );
};

export default TaskFollowUpScreen;
